import { useMutation } from '@tanstack/react-query';

import { DocumentParams } from '../../../../documents/types/DocumentParams';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { deleteFilter } from '../../requests/deleteFilter';

type UseDeleteFilterOptions = {
  onSuccess?: () => void;
};

export const useDeleteFilter = (
  params?: DocumentParams,
  options?: UseDeleteFilterOptions,
) => {
  const { constructDelete } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: async (uuid: string) =>
      deleteFilter(constructDelete, uuid, params),
    onSuccess: options?.onSuccess,
  });

  return { deleteFilter: mutateAsync, ...rest };
};
